export default {
  "content": "<path d=\"M21.465 13.084l-2.878-2.88L5.453 23.339a.654.654 0 00-.2.48l-.747 3.306 3.346-.707a.625.625 0 00.467-.2l13.146-13.133zm3.947-3.947c.52-.52.52-1.36 0-1.88l-.999-.999c-.52-.52-1.36-.52-1.88 0L19.92 8.871l2.879 2.88 2.613-2.614z\"/><rect width=\"32\" height=\"1\" y=\"31.5\" rx=\".5\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "32",
    "height": "32",
    "fill": "#333",
    "viewBox": "0 0 32 32"
  }
};